import React from "react";
import { FaAward, FaChartLine, FaMedal } from "react-icons/fa";
import { GiBlackBelt } from "react-icons/gi";

import {
  DEFAULT_GRADE_IMAGE,
  getBeltName,
} from "../utils/passageGradeUtils";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-orange-200" />
      <p className="mt-3 text-2xl font-bold">{value}</p>
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function GradeHero({ stats, lastGrade }) {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src={DEFAULT_GRADE_IMAGE}
          alt="Passage de grades"
          className="h-full w-full object-cover opacity-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-orange-950/70" />
      </div>

      <div className="relative mx-auto flex min-h-[380px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <GiBlackBelt />
            Grades & progression
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Parcours de ceintures
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            Visualise la progression technique du judoka, son historique de
            ceintures et son suivi des UV pour les passages de Dans.
          </p>
        </div>

        <div className="mt-8 grid max-w-4xl gap-3 sm:grid-cols-3">
          <HeroStat
            icon={GiBlackBelt}
            label="Ceinture actuelle"
            value={lastGrade ? getBeltName(lastGrade) : "—"}
          />

          <HeroStat
            icon={FaAward}
            label="Passages"
            value={stats.totalGrades}
          />

          <HeroStat
            icon={FaChartLine}
            label="UV validées"
            value={`${stats.danCompleted}/${stats.danTotal}`}
          />
        </div>
      </div>
    </header>
  );
}

export default GradeHero;